import React from "react";
import './dashboardsInfo.css';

function DashboardsInfo() {
    return (
        <section id="dashboards-info">
            <div className="container">

                <div className="text-center section-title">
                    <h2 className="display-4">Controle Total do Seu Negócio</h2>
                    <p>Tome decisões baseadas em dados com nossos dashboards intuitivos e completos.</p>
                </div>

                {/* Dashboard de Vendas */}
                <div className="row feature-row">
                    <div className="col-lg-6 order-lg-2">
                        <div className="feature-image-container">
                            <img
                                src="imagens/dash_vendas.png"
                                className="img-fluid feature-image"
                                alt="Dashboard de Vendas R6 ERP"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 order-lg-1 feature-text">
                        <h3>
                            <i className="fas fa-chart-line"></i>
                            Dashboard de Vendas
                        </h3>
                        <p>
                            Acompanhe o desempenho comercial da sua empresa em tempo real. Identifique tendências,
                            monitore metas e impulsione seus resultados com informações precisas.
                        </p>
                        <ul className="list-unstyled feature-benefits">
                            <li><i className="fas fa-check-circle"></i> Evolução de vendas mensal</li>
                            <li><i className="fas fa-check-circle"></i> Produtos mais vendidos e Curva ABC</li>
                            <li><i className="fas fa-check-circle"></i> Ranking de melhores clientes</li>
                            <li><i className="fas fa-check-circle"></i> Acompanhamento de Ticket Médio</li>
                        </ul>
                    </div>
                </div>

                {/* Dashboard Financeiro */}
                <div className="row feature-row">
                    <div className="col-lg-6">
                        <div className="feature-image-container">
                            <img
                                src="imagens/dash_financeiro.png"
                                className="img-fluid feature-image"
                                alt="Dashboard Financeiro R6 ERP"
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 feature-text">
                        <h3>
                            <i className="fas fa-wallet"></i>
                            Gestão Financeira
                        </h3>
                        <p>
                            Tenha a saúde financeira da sua empresa na palma da mão.
                            Controle receitas, despesas e fluxo de caixa com facilidade e segurança.
                        </p>
                        <ul className="list-unstyled feature-benefits">
                            <li><i className="fas fa-check-circle"></i> Previsão de Saldo e Fluxo de Caixa</li>
                            <li><i className="fas fa-check-circle"></i> Controle de Contas a Pagar e Receber</li>
                            <li><i className="fas fa-check-circle"></i> Indicadores de Lucratividade em Tempo Real</li>
                        </ul>
                    </div>
                </div>

            </div>
        </section>
    );
}

export default DashboardsInfo;
